/**
 * Created by vladislav on 25/10/2022
 */

Quests.InitMainConfig = function (location, questsConfig) {
    Object.keys(location.families).forEach((code) => {
        const family = Families[code];

        if (["hero", "resource", "magicplant"].indexOf(family.type) === -1 && code !== "crystal") {
            return;
        }

        Unit.getAllStagesTargets(code).filter((unit) => {
            let curStage = unit.stage - 1, notFirst = false;
            while (curStage >= 0) {
                if (!family.units[curStage].temporary) {
                    notFirst = true;
                }
                curStage--;
            }

            if (!notFirst) {
                return false;
            }

            if (family.units[unit.stage].temporary) {
                return false;
            }

            if (unit.code === "dwarf" || questsConfig[Unit.GetKey(unit)]) {
                return false;
            }

            return true;
        }).forEach((unit) => {
            const data = family.units[unit.stage];
            const isBuildable = data.buildable && cleverapps.parseInterval(data.buildable) > 0;

            const triggerStage = unit.stage - 1;

            questsConfig[Unit.GetKey(unit)] = {
                trigger: {
                    unit: {
                        code: unit.code,
                        stage: triggerStage
                    }
                },
                dynamic: {
                    filter: function (options) {
                        if (options && options.create) {
                            const units = UnitsLibrary.ListByCode(unit.code);
                            const lastOpened = cleverapps.unitsLibrary.findLastOpenedUnit(units);
                            return !lastOpened || lastOpened.stage < unit.stage;
                        }

                        return true;
                    }
                },
                quest: {
                    type: isBuildable ? Map2d.BUILD : Map2d.SPAWN,
                    unit
                }
            };

            if (family.type === "magicplant" && (unit.stage === 1 || unit.stage === 9)) {
                delete questsConfig[Unit.GetKey(unit)].trigger;
            }

            if (!isBuildable && family.type === "hero" && unit.stage === Unit.getAllStagesTargets(unit.code).pop().stage) {
                questsConfig[Unit.GetKey(unit)].trigger.unit.stage = 0;
            }
        });
    });

    if (questsConfig.crystal_1) {
        questsConfig.crystal_1.trigger = undefined;
    }
    if (questsConfig.crystal_2) {
        questsConfig.crystal_2.trigger = undefined;
    }
    if (questsConfig.crystal_3) {
        questsConfig.crystal_3.trigger = undefined;
    }
};

Quests.InitConfig = (function () {
    const initialized = {};

    return function (location) {
        if (initialized[location.locationId]) {
            return;
        }
        initialized[location.locationId] = true;

        if (!QuestsConfig[location.locationId]) {
            const questsConfigBundleName = [`quests_${location.locationId}`, `quests_${location.meta.units}`]
                .find((name) => bundles[name] && bundles[name].jsons.questsconfig_json && bundles[name].jsons.questsconfig_json.resolve());
            if (questsConfigBundleName) {
                QuestsConfig[location.locationId] = bundles[questsConfigBundleName].jsons.questsconfig_json.resolve().getJson();
            }
        }

        const dynamicKey = `${location.locationId}_dynamic`;
        if (QuestsConfig[dynamicKey]) {
            QuestsConfig[location.locationId] = QuestsConfig[location.locationId] || {};
            Object.assign(QuestsConfig[location.locationId], QuestsConfig[dynamicKey]);
            delete QuestsConfig[dynamicKey];
        }

        const questsConfig = QuestsConfig[location.locationId];

        if (!questsConfig) {
            return;
        }

        if (location.locationId === "main") {
            Quests.InitMainConfig(location, questsConfig);
        }

        const questsBar = location.locationConfig.questsBar;
        if (questsBar && !questsBar.totalQuests) {
            questsBar.totalQuests = Object.keys(questsConfig).length;
        }

        Object.keys(questsConfig).forEach((id) => {
            const config = questsConfig[id];
            config.quest.id = id;

            const bundleName = [`quests_${location.locationId}`, `quests_${location.meta.units}`]
                .find((bundleName) => bundles[bundleName] && bundles[bundleName].jsons.quests_json.resolve());

            const questsData = bundles[bundleName].jsons.quests_json.resolve().getJson();

            Quests.appendJsonDataToQuest(config, questsData[id]);
        });
    };
}());

Quests.appendJsonDataToQuest = function (config, data) {
    if (!data) {
        if (config.quest.trigger) {
            console.error(`No data for quest '${config.quest.i}'`);
        }
        return;
    }

    config.dialogue = data.dialogue;

    if (data.goal === undefined) {
        console.error(`No goal specified for quest '${config.quest.i}'`);
        return;
    }
    config.quest.goal = data.goal;

    if (data.prize === undefined) {
        console.error(`No prize specified for quest '${config.quest.i}'`);
        return;
    }
    config.quest.prize = data.prize;
};